import firestore from "../firebase.config";
import React, { useState, useEffect } from "react";
import { Link, BrowserRouter as Router, useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
    Box,
    Card,
    CardActionArea,
    CardMedia,
    CardContent,
    Grid,
    Divider,
    Typography,
} from "@material-ui/core";
import { useAuth } from "../context/AuthContext";
import Footer from "./Components/footer";
import "../App.css";
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

// fetch all videos
const fetchVideos = async () => {
    const data = await firestore.collection("videos").get();
    return data.docs.map((doc) => doc.data());
};


// filter videos
const filterVideos = (filter, allVideos) => {
    if (filter == null || filter.length === 0) {
        return allVideos;
    }

    const filteredVideos = allVideos.filter(function (vid) {
        return filter.some(function (fil) {
            return vid.category === fil;
        });
    });

    return filteredVideos;
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    paper: {
        width: "100%",
        marginBottom: theme.spacing(2),
    },
    filterbar: {
        margin: theme.spacing(2),
    },

}));


function SearchCategory() {
    const [videos, setVideos] = useState([]);
    const { currentUser } = useAuth();
    const classes = useStyles();

    useEffect(() => {
        fetchVideos().then((allVideos) => {
            setVideos(allVideos);
        });
    }, []);

    const { search } = window.location;
    const query = new URLSearchParams(search).get('s');

    const filterVideos = (videos, query) => {
        if (!query) {
            return videos;
        }
    
        return videos.filter((video) => {
            const relatedVideo = video.category.toLowerCase();
            return relatedVideo.includes(query);
        });
    };

    const [searchQuery, setSearchQuery] = useState(query || '');
    const SearchVideos = filterVideos(videos, searchQuery);

    return (
        <div>
            <div className="wrapper">

                {/* Search bar for user to enter the words */}

                <Box 
                    justifyContent="center" 
                    alignItems="center"
                    display="flex"
                    p={5}
                    m={5}>
                    <Box p={5} m={5}>
                    <Typography
                        variant="h5"
                        style={{ marginBottom: 20, textAlign: "center" }}
                    >
                        Search Videos by Category
                    </Typography>
                    <FormControl fullWidth variant="standard">
                        <TextField 
                            fullWidth
                            value={searchQuery}
                            id="header-search" 
                            label="Category" 
                            variant="standard" 
                            onChange={e => setSearchQuery(e.target.value)}
                            name="s"
                            type="string"
                            />
                    </FormControl>
                    </Box>
                </Box>



                {/* Display the related videos if have searched certain words
                    else display all video */}

                {SearchVideos && (
                    <div className="category">
                        <Grid container spacing={3}>
                            {SearchVideos.map((vid, i) => {
                                return (
                                    <Grid item xs={3}>
                                        <Link
                                            key={i}
                                            to={`/playVideo/${vid.videoId}`}
                                            style={{ textDecoration: "none" }}
                                        >
                                            <Card>
                                                <CardActionArea>
                                                    <CardMedia
                                                        component="img"
                                                        height="150"
                                                        width="150"
                                                        image={`https://img.youtube.com/vi/${vid.videoId}/default.jpg`}
                                                        title={vid.title}
                                                        alt={vid.title}
                                                    />
                                                </CardActionArea>
                                                <CardContent>
                                                    <Typography noWrap>
                                                        {" "}
                                                        {vid.title}{" "}
                                                    </Typography>
                                                </CardContent>
                                                <Box
                                                    display="flex"
                                                    justifyContent="flex-end"
                                                    mr={2}
                                                >
                                                    <Box
                                                        bgcolor="text.primary"
                                                        color="background.paper"
                                                        mb={1}
                                                        borderRadius={16}
                                                        width="50%"
                                                        height="10%"
                                                    >
                                                        <Typography
                                                            noWrap
                                                            style={{
                                                                fontSize: 12,
                                                            }}
                                                        >
                                                            {vid.category}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Card>
                                        </Link>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </div>
                )}
        </div>
        <Footer />
        </div>
    );
}

export default SearchCategory;
